module.exports = __webpack_public_path__ + "static/gira-sans-light-8ec773409a9a4804e0f74b35a32c98ff.woff";